import { createFileRoute } from '@tanstack/react-router';

import { Loading } from '@/components/core';
import { Integration } from '@/features/agents';

export const Route = createFileRoute('/_auth/agents/$agentId/integration')({
  component: Integration,
  pendingComponent: () => <Loading className="h-[100vh]" label="Loading flow" />,
});
